// src/components/RequireAuth.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

export default function RequireAuth({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setChecking(false);

      if (!u) {
        navigate("/", { replace: true });
      }
    });

    return () => unsub();
  }, [navigate]);

  // still checking auth status
  if (checking) return <div style={{ padding: 20 }}>Refreshing QuickBill...</div>;

  // not logged in → redirected already
  if (!user) return null;

  // logged in → show page
  return children;
}
